import { useUserConfig } from '../context/UserConfigContext';
import { IExerciseResultItem } from '../redux/api/exercises/interfaces';
import { DEFAULT_SET_ITEM_REST_SEC } from '../utils/training/set-utils';

export function useDefaultSetItemRestSec() {
  const { options } = useUserConfig();
  const configRest = options.defaultSetItemRestSec;

  const defaultRestForNewEmptyItem = configRest ?? DEFAULT_SET_ITEM_REST_SEC;

  function resolveRestForFirstItemAfterExerciseSelect(
    result: IExerciseResultItem | undefined,
  ): number {
    if (configRest !== null) return configRest;
    if (result?.trainingSetItem?.rest != null)
      return result.trainingSetItem.rest;
    return DEFAULT_SET_ITEM_REST_SEC;
  }

  return {
    configRest,
    defaultRestForNewEmptyItem,
    resolveRestForFirstItemAfterExerciseSelect,
  };
}
